import { OPEN_MODAL } from '../modalActions'
import { trackEvent } from 'aria-viewer/core/middleware/analyticsMiddleware'
import * as EVENTS from 'aria-viewer/analytics/constants/desktopAnalytics'
import { getTourData } from 'aria-viewer/analytics/utils/analyticUtils'
import ModalContentTypes from 'aria-viewer/modal/constants/ModalContentTypes'

const modalAnalytics = {
    [OPEN_MODAL]: (getState, action) => {
        if (action.modal.content.type === ModalContentTypes.REGISTRATION) {
            const { inst_name, loc_name, owner_id, loc_id, stoptitle } = getTourData()(getState)

            const initiatedBy = EVENTS.INIT_BY[action.modal.content.initBy]

            return trackEvent(EVENTS.EXP_REG_VIEWED, {
                Institution: inst_name,
                Location: loc_name,
                Inst_ID: owner_id,
                Loc_ID: loc_id,
                Stop: stoptitle,
                Initiated_by: initiatedBy,
            })
        }
    },
}

export default modalAnalytics
